"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const react_select_1 = __importDefault(require("react-select"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledDiv = styled_components_1.default.div `
  min-width: ${(props) => props.width || "10rem"};
`;
exports.TableGroupModal = ({ selectedGroups, onToggle, onSave, tableGroups, isOpen, }) => {
    var _a, _b;
    const [formTagValue, setFormTagValue] = react_1.useState("");
    const [formTagKey, setFormTagKey] = react_1.useState("");
    const [selectedTags, setSelectedTags] = react_1.useState([]);
    react_1.useEffect(() => {
        if (selectedGroups.length) {
            setSelectedTags(selectedGroups);
        }
    }, [selectedGroups]);
    const addTag = () => {
        if (!formTagKey)
            return;
        const newTag = formTagValue ? `${formTagKey}=${formTagValue}` : formTagKey;
        const tags = [...selectedTags, newTag].filter((tag, index, all) => all.indexOf(tag) === index);
        setSelectedTags(tags);
    };
    const removeTag = (tag) => {
        const reTag = new RegExp(`^${tag}$`);
        const filteredTags = selectedTags.filter((tag) => !reTag.test(tag));
        setSelectedTags(filteredTags);
    };
    const onSelectChange = (option, action) => {
        console.log(option, action);
        const name = action.name;
        if (name === "formTagKey") {
            setFormTagKey(option.value);
        }
        if (name === "formTagValue") {
            setFormTagValue(option.value);
        }
    };
    const tagKeyOptions = tableGroups
        .map((g) => g.key)
        .filter((g) => !selectedTags.map((x) => x.split("=")[0]).includes(g))
        .map((t) => ({ label: t, value: t }));
    const tagValueOptions = ((_b = (_a = tableGroups
        .find((x) => x.key === formTagKey)) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.map((t) => ({ label: t, value: t }))) || [];
    return (react_1.default.createElement(reactstrap_1.Modal, { isOpen: isOpen, toggle: onToggle, size: "lg" },
        react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: onToggle }, "Add Custom tag Groups"),
        react_1.default.createElement(reactstrap_1.ModalBody, { className: "p-3" },
            react_1.default.createElement(reactstrap_1.Container, { fluid: true, className: "mt-3" },
                react_1.default.createElement(reactstrap_1.Row, null, selectedTags.map((tag) => (react_1.default.createElement(reactstrap_1.Badge, { className: "mr-3", key: tag, color: "primary" },
                    react_1.default.createElement("span", null, tag),
                    react_1.default.createElement("span", { className: "cursor-pointer ml-2", onClick: () => removeTag(tag) },
                        react_1.default.createElement("i", { className: "fa fa-close " })))))),
                react_1.default.createElement(reactstrap_1.Row, { className: "align-items-end" },
                    react_1.default.createElement(reactstrap_1.Col, { md: 10, className: "d-flex" },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(reactstrap_1.Label, null, "Tag Key"),
                            react_1.default.createElement(exports.StyledDiv, { width: "200px" },
                                react_1.default.createElement(react_select_1.default, { options: tagKeyOptions, name: "formTagKey", onChange: onSelectChange }))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(reactstrap_1.Label, null, "Tag Value (Optional)"),
                            react_1.default.createElement(exports.StyledDiv, { width: "200px", className: "ml-2" },
                                react_1.default.createElement(react_select_1.default, { options: tagValueOptions, name: "formTagValue", onChange: onSelectChange })))),
                    react_1.default.createElement(reactstrap_1.Col, { md: 2, className: "d-flex justify-content-end" },
                        react_1.default.createElement(reactstrap_1.Button, { color: "primary", className: "w-100", onClick: addTag }, "Add"))))),
        react_1.default.createElement(reactstrap_1.ModalFooter, null,
            react_1.default.createElement(reactstrap_1.Button, { className: "mr-2", color: "primary", size: "sm", onClick: () => {
                    onSave && onSave(selectedTags);
                    onToggle();
                } }, "Save"),
            react_1.default.createElement(reactstrap_1.Button, { color: "secondary", size: "sm", onClick: onToggle }, "Cancel"))));
};
//# sourceMappingURL=TableGroupModal.js.map